import { getLanguageFromLocalStorage } from "@gtmhub/localization";

export const MARGIN_SIZE = 8;
export const CHIP_HEIGHT = 28;

export function sortArrayByProperty<T>(array: T[], property: keyof T): T[] {
  return array.sort((a, b) => {
    const valueA = String(a[property]).toLowerCase();
    const valueB = String(b[property]).toLowerCase();
    if (valueA < valueB) {
      return -1;
    }
    if (valueA > valueB) {
      return 1;
    }
    return 0;
  });
}

export const getViewMoreButtonWidth = (): number => {
  const language = getLanguageFromLocalStorage();
  switch (language) {
    case "french":
      return 87 + MARGIN_SIZE;
    case "portuguese":
      return 86 + MARGIN_SIZE;
    case "spanish":
      return 83 + MARGIN_SIZE;
    case "german":
      return 105 + MARGIN_SIZE;
    case "italian":
      return 87 + MARGIN_SIZE;
    case "chinese":
      return 127 + MARGIN_SIZE;
    case "bulgarian":
      return 83 + MARGIN_SIZE;
    case "english":
      return 91 + MARGIN_SIZE;
    default:
      return 91 + MARGIN_SIZE;
  }
};
